import { Box, Button, Grid2, Typography } from '@mui/material'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KPIFilters from './KPIFilters';
import FeedbackElements from '../shared/FeedbackElements';
import { useContext, useEffect, useState } from 'react';
import CustomShaped from '../styled/CustomShaped';
import { KPIContext } from '../../contexts/kpiContext';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { applyFilters, getKpiInsight, selectKpiInsight } from '../../store/slices/kpiReportingSlice';
import { selectIfFeedbackGiven, submitFeedback } from '../../store/slices/feedbackSlice';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { MESSAGES } from '../../constants/Messages';
import ChartContainer from '../charts/ChartContainer';
import { createDigest as createKpiFiltersDigest } from '../../utils/Hasher';
import Tier3KPIsNew from './Tier3KPIsNew';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadKPIInsights } from '../../api/KpiReportingApi';
import DarkAdnocLoadingProgress from '../shared/DarkAdnocLoadingProgress';


function KPIDetails() {
    const dispatch = useDispatch<AppDispatch>();
    const kpiContext = useContext(KPIContext);

    const kpiInsight = useSelector(selectKpiInsight);
    const hasFeedback = useSelector(selectIfFeedbackGiven(`${kpiContext?.state.filters.selectedKpiName}-insight`));

    const [fileDownloadProgress, setFileDownloadProgress] = useState(false)

    useEffect(() => {
        if (kpiContext?.state.filters.selectedKpiName && kpiInsight[kpiContext?.state.filters.selectedKpiName] === null) {
            dispatch(applyFilters({
                ...kpiContext?.state.filters,
                kpiName: kpiContext?.state.filters.selectedKpiName
            }))
            dispatch(getKpiInsight({
                ...kpiContext?.state.filters,
                kpiName: kpiContext?.state.filters.selectedKpiName
            }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, kpiContext?.state.filters.selectedKpiName])

    const getFiltersDigest = async () => {
        return await createKpiFiltersDigest(kpiContext?.state.filters!);
    }

    const handleFeedback = (isThumbUp: boolean, comment?: string) => {
        getFiltersDigest()
            .then(digest => {
                dispatch(submitFeedback({
                    rating: isThumbUp,
                    comment: comment || '',
                    entry_id: digest
                }))
            })
    }

    const handleDownload = async () => {
        setFileDownloadProgress(true)
        const result = await downloadKPIInsights({
            ...kpiContext?.state.filters,
            kpiName: kpiContext?.state.filters.selectedKpiName
        })
        if (result) {
            setFileDownloadProgress(false)
        }
    }

    return (
        <>
            {fileDownloadProgress && <DarkAdnocLoadingProgress size='xlarge'></DarkAdnocLoadingProgress>}
            <Box sx={{
                position: 'absolute',
                right: '5vw',
            }}>
                <Button
                    onClick={handleDownload}
                    variant='outlined'
                    sx={{
                        paddingX: 2,
                        paddingY: 1,
                        color: '#00A9B1',
                        border: '0.125vw solid #00A9B1',
                        borderRadius: '0.5vw',
                        outline: 'none',
                        textTransform: 'capitalize',
                        display: 'flex',
                        gap: 1,
                    }}>
                    <DownloadIcon fontSize='large' />
                    <Typography variant='body1' sx={{
                        lineHeight: 1.125,
                        fontWeight: 700,
                    }}>
                        Download KPI Tier
                        <br />
                        Data Sources
                    </Typography>
                </Button>
            </Box>
            <Grid2 size={{ xs: 8 }} sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 5,
            }}>
                <Grid2 sx={{
                    display: 'grid',
                    gridTemplateColumns: '25% 75%',
                }}>
                    <Box sx={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'start',
                    }}>
                        <Box sx={{
                            width: '100%',
                            paddingY: 1,
                            background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) -7.34%, rgba(255, 255, 255, 0.52) 50%)',
                        }}>
                            <Typography variant='h4' sx={{
                                borderLeft: '0.5vw solid #41D9E1',
                                paddingLeft: 2,
                                fontWeight: 600,
                            }}>
                                Tier 3 KPIs
                            </Typography>
                        </Box>
                        <Button variant='text'
                            disableRipple
                            onClick={() => kpiContext?.toggleShowDetails(false)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                            <KeyboardArrowLeft fontSize='small' htmlColor='var(--text-dark)' />
                            <Typography variant='body1' sx={{
                                display: 'inline-block',
                                fontWeight: 600,
                                textDecoration: 'underline',
                                color: '#00A9B1'
                            }}>
                                KPI Reporting
                            </Typography>
                        </Button>
                    </Box>
                    <KPIFilters></KPIFilters>
                </Grid2>
            </Grid2>
            <Grid2 size={{ xs: 8 }} sx={{
                display: 'grid',
                gridTemplateColumns: '27.5% 70%',
                columnGap: '2.5%',
            }}>
                <Grid2 sx={{
                    height: 'max-content',
                    position: 'relative'
                }}>
                    <Tier3KPIsNew></Tier3KPIsNew>
                </Grid2>
                {
                    kpiContext?.state.filters.selectedKpiName && kpiInsight[kpiContext?.state.filters.selectedKpiName] === null &&
                    <Grid2 sx={{
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        gap: 4,
                    }}>
                        <CustomShaped borderSize='large'>
                            <Box sx={{
                                minHeight: '15vh !important',
                                display: 'grid',
                                placeContent: 'center'
                            }}>
                                <Typography variant='subtitle1'>
                                    {MESSAGES.NO_KPI_INSIGHTS}
                                </Typography>
                            </Box>
                        </CustomShaped>
                    </Grid2>
                }
                {kpiContext?.state.filters.selectedKpiName && kpiInsight[kpiContext?.state.filters.selectedKpiName] && <Grid2 container sx={{
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    gap: 4,
                }}>
                    {
                        kpiInsight[kpiContext?.state.filters.selectedKpiName]
                            .Graph.filter((s: any) => s !== null).map((g: any, index: number) => {
                                return <CustomShaped key={`chart-${index}`} borderSize='large'>
                                    <ChartContainer visual={g}></ChartContainer>
                                </CustomShaped>
                            })
                    }
                    <CustomShaped borderSize='xlarge'>
                        <Typography variant='body1' component={'div'} sx={{ marginBottom: 2, }}>
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {kpiInsight[kpiContext?.state.filters.selectedKpiName].Insight}
                            </ReactMarkdown>
                        </Typography>
                        <Box sx={{
                            width: '100%',
                            marginLeft: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end'
                        }}>
                            <FeedbackElements hideBookmark={true}
                                thumbFn={handleFeedback}
                                thumbUp={hasFeedback}
                                copyFn={() => navigator.clipboard.writeText(kpiInsight[kpiContext?.state.filters.selectedKpiName!].Insight)}></FeedbackElements>
                        </Box>
                    </CustomShaped>
                </Grid2>}
            </Grid2>
        </>
    )
}

export default KPIDetails